var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Views:_ListView_Filled:Active",
    "data-name": "icons / Views: ListView Filled:Active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_my_kaercher_no_K_oth_3_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.815.069a4.934,4.934,0,0,1-.839.595,5.518,5.518,0,0,1,3.1,4.955v5.47H.939V5.618a5.54,5.54,0,0,1,3.2-5A5.42,5.42,0,0,1,3.3,0,6.454,6.454,0,0,0,0,5.609V12H13V5.609A6.443,6.443,0,0,0,9.815.069Z",
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M4,10C1.794,10,0,7.76,0,5S1.794,0,4,0,8,2.24,8,5,6.2,10,4,10Z",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M3.108,0C1.4,0,0,1.8,0,4.013S1.391,8.025,3.108,8.025s3.108-1.8,3.108-4.013S4.815,0,3.108,0Z",
    transform: "translate(3.892 0.977)",
    fill: "#f8f8f8"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.a8727101352ca8bed36f21cbe42b2326.svg";